import { Injectable } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { Baseservice } from "./baseservice";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class ScannerService extends Baseservice {
  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("", http, authentication);
  }
  getScanners() {
    return this.http.get(this.url + "scanner/all");
  }
  getScannerByID(id) {
    return this.http.get(this.url + "scanner/" + id);
  }

  getScannerByDeviceID(id) {
    return this.http.get(this.url + "scannerbydeviceid/" + id);
  }

  add(data) {
    return this.http.post(this.url + "scanner/add/", data);
  }

  update(data) {
    console.log(this.url, JSON.stringify(data));
    return this.http.put(this.url + "scanner/update/", data);
  }
  delete(id) {
    return this.http.get(this.url + "scanner/delete/" + id);
  }

  getKioskScanner() {
    return this.http.get(`${environment.consoleAPIUrl}/getscanner`);
  }

  relaunch(){
    return this.http.get(`${environment.consoleAPIUrl}/relaunch`);
  }
}
